import React from 'react';
import { Input } from './Input';

export interface LicensePlateInputProps extends Omit<React.ComponentProps<typeof Input>, 'value' | 'onChange'> {
	value?: string;
	onChange?: (value: string) => void;
}

// Normalises plate input: uppercases and keeps only plate-friendly characters (A-Z, 0-9,
// space, dash), collapsing repeated spaces. Deliberately NOT country-validated — international
// truckers carry many plate formats, so we tidy the input rather than reject it.
function normalizePlate(raw: string): string {
	return raw
		.toUpperCase()
		.replace(/[^A-Z0-9 -]/g, '')
		.replace(/\s{2,}/g, ' ')
		.replace(/^\s+/, '');
}

export const LicensePlateInput = React.forwardRef<HTMLInputElement, LicensePlateInputProps>(
	({ value, onChange, ...props }, ref) => (
		<Input
			ref={ref}
			value={value ?? ''}
			onChange={(e) => onChange?.(normalizePlate(e.target.value))}
			autoCapitalize="characters"
			autoCorrect="off"
			spellCheck={false}
			{...props}
		/>
	),
);
LicensePlateInput.displayName = 'LicensePlateInput';
